import { CronSelections, DaysBySelections } from '../enums/schedules/cron-prop-selections';
import { CronScheduleProps } from '../interfaces/schedule-tasks/cron-schedule-props';

function validateInterval(
	label: string,
	minValue: number,
	maxValue: number,
	values?: number[]
): string {
	if (!values || values.length === 0) {
		return '*';
	}
	values.forEach(value => {
		if (value < minValue) {
			throw new Error(
				`Cron Parser: ${label} can only contain values greater or equal to ${minValue}.`
			);
		}
		if (value > maxValue) {
			throw new Error(`Cron Parser: ${label} can only be values smaller or equal to ${maxValue}.`);
		}
	});

	return values.join(',');
}

export function BuildCronString(scheduleCalendarProps: CronScheduleProps) {
	let minutesStr = '*';
	let hoursStr = '*';
	let dayOfMonthStr = '*';
	let dayOfWeekStr = '*';
	let monthStr = '*';
	if (scheduleCalendarProps.minuteSelection === CronSelections.At) {
		minutesStr = validateInterval('Minutes', 0, 59, scheduleCalendarProps.minutes);
	} else if (scheduleCalendarProps.minutes[0]) {
		minutesStr = `*/${scheduleCalendarProps.minutes[0]}`;
	}

	if (scheduleCalendarProps.hourSelection === CronSelections.At) {
		hoursStr = validateInterval('Hours', 0, 23, scheduleCalendarProps.hours);
	} else if (scheduleCalendarProps.hours[0]) {
		hoursStr = `*/${scheduleCalendarProps.hours[0]}`;
	}

	if (scheduleCalendarProps.daysBy === DaysBySelections.Week) {
		dayOfWeekStr = validateInterval('Day Of The Week', 0, 7, scheduleCalendarProps.days);
	} else if (scheduleCalendarProps.daySelection === CronSelections.At) {
		dayOfMonthStr = validateInterval('Day Of The Month', 1, 31, scheduleCalendarProps.days);
	} else if (scheduleCalendarProps.days[0]) {
		dayOfMonthStr = `*/${scheduleCalendarProps.days[0]}`;
	}

	if (scheduleCalendarProps.month.length > 0) {
		monthStr = validateInterval('Months', 1, 12, scheduleCalendarProps.month);
	}

	const lastDayOfMonth = scheduleCalendarProps.isLastDayOfTheMonth ? 'L' : '';
	return `${minutesStr} ${hoursStr} ${dayOfMonthStr} ${monthStr} ${dayOfWeekStr}${lastDayOfMonth}`;
}
